import { Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { appReducersActions } from "../store/reducers/app";
import { getUrlParamsBySearch } from "../utils";

const Header = () => {
  const dispatch = useDispatch();
  const { currentPage } = useSelector((state) => state.app);
  const handlePreview = (url) => {
    dispatch(appReducersActions.setPreviewModal({ show: true, url }));
  };
  const handleClick = (e) => {
    let el = e.target;
    if (el.nodeName.toLocaleLowerCase() == "img") {
      let src = el.src;
      if (el.naturalWidth > 50 || el.naturalHeight > 50) {
        handlePreview(src);
      }
    }
  };
  return (
    <Form.Item
      noStyle
      shouldUpdate={(prev, cur) => cur.suveryInfo != prev.suveryInfo}
    >
      {({ getFieldValue }) => {
        const info = getFieldValue("suveryInfo") || {};
        const { showName, showLogo } = info;
        let isFirstPage = currentPage == 1;
        let curbrand = getUrlParamsBySearch(window.location.search).brand;
        let picUrl = info.logoList?.find((o) => o.brand == curbrand)?.picUrl;
        if (!picUrl) picUrl = info.logoList?.[0]?.picUrl;
        return (
          <div className="header-box">
            {showLogo && isFirstPage && picUrl && (
              <div className="logo-box">
                <img className="logo" src={picUrl} alt=""></img>
              </div>
            )}
            {showName && <div className="title">{info.name}</div>}
            {isFirstPage && info.description && (
              <div
                className="description"
                dangerouslySetInnerHTML={{ __html: info.description }}
                onClick={handleClick}
              ></div>
            )}
          </div>
        );
      }}
    </Form.Item>
  );
};

export default Header;
